// extracted by mini-css-extract-plugin
module.exports = {"isMobile":"styles-styles-module--isMobile--SdQT7"};